import { useEffect, useState } from "react"
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _AdquisitionItemCDP, _Inbox, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { StepWizard, Wizard } from "../../bpm/config/Componentes/wizard/Wizard";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BudgetCDPFactoryForm } from "./BudgetCDPFactoryForm";
import { BudgetCDPFactoryValue } from "./BudgetCDPFactoryValue";
import { BudgetCDPFactoryDocument } from "./BudgetCDPFactoryDocument";
import { Alert } from "../../theme/Component/Alert";
import { BasicButton } from "../../theme/Component/BasicButton";
import { _BudgetSource } from "../../../core/services/dataBean/EntityCatalogVdos";

interface MapProperties {
    FormData: Record<string, any>;
    ObjectList: object[];
    DocumentList: Record<string, any>;
}

interface ProcedureFunctions {
    _procedure: any;
    _pocessData?: any;
    _exportMap: Function;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure?: ProcedureFunctions;
    modal?: boolean;
}


export const BudgetCDPFactory = ({ modal = true, configProcedure }: Props) => {

    const bduget = useDataBean(_BudgetSource);
    const cdpService = useDataBean(_AdquisitionItemCDP);

    const [props, setProps] = useState<any>({});
    const [obs, setObs] = useState<string>("");
    const [adquisitionItem, setAdquisitionItem] = useState<any>({})

    const [canDiscard, setCanDiscard] = useState<boolean>(false);
    const [map, setMap] = useState<MapProperties>({
        FormData: {},
        ObjectList: [],
        DocumentList: {}
    });

    useEffect(() => {
        if (props.IDAdquisitionItem) {
            getItem()
        }
    }, [props])

    const getItem = () => {
        bduget.instance.getAdquisitionItem(props?.IDAdquisitionItem, true).then(
            (resp) => {
                setAdquisitionItem(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo cargar correctamente la necesidad")
            }
        )
    }

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            const x = configProcedure?._procedure ? configProcedure._procedure.IDProcedureImp : null;
            setProps({ ...configProcedure?._pocessData?.Props, "IDPIMP": x })
        }
    }, [configProcedure?._pocessData])

    const onExportMap = (cdp) => {
        let doc = {
            IDAdquisitionItem: props.IDAdquisitionItem,
            IDDocument: props.IDDocument ?? cdp.IDDocument,
            DocumentDate: props.DocumentDate ?? cdp.DocumentDate,
            Mnemonic: props.Mnemonic ?? cdp.Mnemonic,
            Consecutive: props.Consecutive ?? cdp.Consecutive,
        }

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(props.IDDocument ? obs : `Se genera el Documento ${doc.Mnemonic} - ${doc.Consecutive} en el proceso`)
        }

        setCDPtoItem(doc);

    }


    const setCDPtoItem = (doc) => {
        cdpService.instance.setAdquisitionItemToCDP(adquisitionItem?.IDAdquisitionItem, doc.IDDocument, doc.DocumentDate, _single.getAccountID(), true).then(
            (resp) => {
                if (configProcedure?._exportMap) {
                    configProcedure?._exportMap(doc)
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    useEffect(() => {
        if (map.DocumentList.MSGList?.length > 0) {
            setCanDiscard(true)
        } else {
            setCanDiscard(false)
        }
    }, [map.DocumentList])

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { },
            children: <BudgetCDPFactoryForm onChange={(e) => { setMap({ ...map, "FormData": e }) }} />,
            validButton: (map.FormData.Date && map.FormData.BudgetIDType),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Rubros Presupuestales',
            onEvent: () => { },
            children: <BudgetCDPFactoryValue _AdquisitionItem={adquisitionItem} props={props} formData={map.FormData} onChange={(e) => { setMap({ ...map, "ObjectList": e }) }} />,
            validButton: (map.ObjectList.length > 0),
            canReturn: true
        },
        {
            keyID: "2",
            name: 'PASO 3. Generar Certificado de Disponibilidad Presupuestal',
            onEvent: () => { onExportMap(map.DocumentList.Response) },
            children:
                <BudgetCDPFactoryDocument
                    eventCreate={(e) => {
                        if (configProcedure?._pushProps) {
                            configProcedure?._pushProps(e)
                        }
                    }}
                    objectList={map.ObjectList}
                    formData={map.FormData}
                    onChange={(e) => { setMap({ ...map, "DocumentList": e }) }}
                />,
            validButton: (map.DocumentList?.Response?.IDDocument ? true : false),
            canReturn: canDiscard,
            canDiscard: canDiscard,
            labelList: { labelNext: `${props.IDAdquisitionItem ? "Asociar CDP" : "Finalizar Proceso"}` }
        }
    ]

    const [invalid, setInvalid] = useState<boolean>(false)

    return (
        <>
            {modal ?
                <div className="row">
                    <div className="col-md-12">
                        {configProcedure?._procedure?.IDProcedureImp ?
                            <>
                                {props.IDDocument ?
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Alert clase="info text-center" children={`Ya se creo el Documento ${props.Mnemonic} - ${props.Consecutive} para este proceso`} />
                                        </div>
                                        <div className="col-md-12">
                                            <label>Observaciones:</label>
                                            <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} onBlur={() => { setInvalid(false) }} value={obs} onChange={(e) => { setObs(e.target.value) }} />
                                        </div>
                                        <div className="col-md-12 mt-4">
                                            <BasicButton eventClick={() => {
                                                if (obs && obs.length > 15) {
                                                    setCDPtoItem(props)
                                                } else {
                                                    setInvalid(true);
                                                    toast.error("La justificación debe tener un mínimo de 15 caracteres");
                                                }
                                            }} icon="ri-save-line" children={"Continuar"} />
                                        </div>
                                    </div>
                                    :
                                    <Wizard title="Certificado Disponibilidad Presupuestal" listStep={steps} />
                                }
                            </>
                            :
                            <Wizard title="Certificado Disponibilidad Presupuestal" listStep={steps} />
                        }
                    </div>
                </div>
                :
                <BasicPage titulo="Certificado Disponibilidad Presupuestal" >
                    <Wizard title="Certificado Disponibilidad Presupuestal" listStep={steps} />
                </BasicPage>
            }
        </>
    )
}